import React, { useState, useEffect } from "react";
import { Box, Text } from "@chakra-ui/react";
const Installed_Crm = () => {
  return (
    <Box mt="16px" className="form-intergrate-body">
      <Text
        fontSize="14px"
        fontWeight="400"
        w="612px"
        h="40px"
        color="#12344D"
        align="center"
      >
        All your contacts will be automatically synced with your Freshworks CRM
        account on form{" "}
        <Text align="center" color="#12344D" fontSize="14px" fontWeight="400">
          submissions.
        </Text>
      </Text>
    </Box>
  );
};

export default Installed_Crm;
